export const mockFeedData = {
	sections: [
		{
			id: "featured-1",
			type: "featured",
			content: {
				title: "Book of the Month",
				subtitle: "Monthly Featured Content",
				description: "Discover this month's featured book and join the discussion. This month we're exploring 'The Psychology of Money' by Morgan Housel, a fascinating look at how our relationship with money shapes our lives.",
				imageUrl: "https://images.unsplash.com/photo-1544947950-fa07a98d237f?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1287&q=80",
				actionLabel: "Learn More",
				stats: {
					readingCount: 24,
					readingLabel: "Reading",
					discussionCount: 12,
					discussionLabel: "Discussions",
				},
				showStats: true,
			},
		},
		{
			id: "events-1",
			type: "events",
			content: {
				title: "Community Meetup",
				date: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toISOString(), // 7 days from now
				location: "Central Library, Meeting Room A",
				description: "Join us for our monthly community meetup! We'll be discussing this month's book and planning future events.",
				actionLabel: "RSVP",
			},
		},
		{
			id: "quickaccess-1",
			type: "quickAccess",
			content: {
				items: [
					{
						id: "qa-1",
						title: "Current Discussion",
						icon: "chatbubbles-outline",
						url: "#",
					},
					{
						id: "qa-2",
						title: "Reading List",
						icon: "book-outline",
						url: "#",
					},
					{
						id: "qa-3",
						title: "Upcoming Events",
						icon: "calendar-outline",
						url: "#",
						badge: "3",
					},
					{
						id: "qa-4",
						title: "My Profile",
						icon: "person-outline",
						url: "#",
					},
				],
			},
		},
		{
			id: "activity-1",
			type: "activity",
			content: {
				items: [
					{
						id: "act-1",
						user: "Sarah Johnson",
						action: "started reading",
						target: "The Psychology of Money",
						time: "2 hours ago",
						icon: "book-outline",
						hasInteraction: true,
					},
					{
						id: "act-2",
						user: "Michael Chen",
						action: "commented on",
						target: "Chapter 3 Discussion",
						time: "4 hours ago",
						icon: "chatbubble-outline",
						hasInteraction: true,
					},
					{
						id: "act-3",
						user: "Emma Wilson",
						action: "is attending",
						target: "Community Meetup",
						time: "Yesterday",
						icon: "calendar-outline",
						hasInteraction: false,
					},
					{
						id: "act-4",
						user: "David Kim",
						action: "finished reading",
						target: "Atomic Habits",
						time: "2 days ago",
						icon: "checkmark-circle-outline",
						hasInteraction: true,
					},
				],
			},
		},
		{
			id: "announcements-1",
			type: "announcements",
			content: {
				items: [
					{
						id: "ann-1",
						title: "New Book Club Selection",
						description: "We're excited to announce our next book club selection: 'Atomic Habits' by James Clear. Voting is now open for the following month!",
						time: "2 days ago",
						priority: "normal",
						hasAction: true,
					},
					{
						id: "ann-2",
						title: "Website Maintenance",
						description: "Our website will be undergoing maintenance this weekend. Some features may be temporarily unavailable.",
						time: "3 days ago",
						priority: "high",
						hasAction: false,
					},
					{
						id: "ann-3",
						title: "Community Guidelines Update",
						description: "We've updated our community guidelines to ensure a positive experience for all members. Please review the changes.",
						time: "1 week ago",
						priority: "normal",
						hasAction: true,
					},
				],
			},
		},
	],
};
